import { mapControl } from '@/constants';
import { workerService, fulfillmentService, } from '@/services';
import { parseWorkerAttendCode, parseWorkerData, } from '@/lib/map-control/helper';
const { mapControlAttendCode } = mapControl;
export const actionType = {
    addWorker: 'addWorker',
    getWorker: 'getWorker',
    updateWorker: 'updateWorker',
    addRelatedWorker: 'addRelatedWorker',
    clearRelatedWorker: 'clearRelatedWorker',
    getFulfillment: 'getFulfillment',
    deleteWorkerOrder: 'deleteWorkerOrder',
    deleteWorker: 'deleteWorker',
    setSelectedWorker: 'setSelectedWorker',
    onOffWorker: 'onOffWorker',
    setWorkerTotalCount: 'setWorkerTotalCount',
    setWorkerFilter: 'setWorkerFilter',
    updateStatusWorkerCount: 'updateStatusWorkerCount',
    deleteAllWorker: 'deleteAllWorker',
    inputSearchWorkerQuery: 'inputSearchWorkerQuery',
    setIsHideShareWorker: 'setIsHideShareWorker',
    setIsHideWorkerMarker: 'setIsHideWorkerMarker',
};
const action = {
    /**
     * 워커의 특정 주문 제거
     * @param {boolean} isDeleteOffWorkerWhenEmptyOrder 주문이 없는 퇴근 라이더면 제거
     */
    [actionType.deleteWorkerOrder]({ dispatch, state, commit }, { workerCode, orderId, isDeleteOffWorkerWhenEmptyOrder = true, }) {
        const workerData = state.workerList[workerCode];
        workerData.deleteOrder(orderId);
        workerData.updateOrderCount();
        if (isDeleteOffWorkerWhenEmptyOrder
            && workerData.isEmptyOrder()) {
            dispatch('deleteWorker', workerCode);
            return;
        }
        commit('UPDATE_WORKER', workerData);
    },
    async [actionType.getWorker]({ commit }, workerCode) {
        const response = await workerService.getWorker({
            workerCode,
        });
        commit('SET_MODAL_WORKER_DATA', response.data);
    },
    /**
     * 풀필먼트 조회
     * @param param0
     * @param isDist 총판 여부 판단
     */
    async [actionType.getFulfillment]({ commit, dispatch }, { subscribeHubId, distributorId, }) {
        // 허브코드 없으면 총판
        const getTargetFulfillment = !subscribeHubId
            ? fulfillmentService.getFulfillment
            : fulfillmentService.getFulfillment;
        const { list } = await getTargetFulfillment(distributorId, subscribeHubId);
        // 테스트 사용시
        // 안정화 될 때까지 더미 데이터 유지
        // await new Promise((r) => setTimeout(r, 1500));
        // const { data: fulfillmentData } = dummyWorkerList;
        const result = parseWorkerData(subscribeHubId || distributorId, list);
        commit('SET_WORKER_LIST', result);
        dispatch(actionType.setWorkerTotalCount);
    },
    [actionType.setSelectedWorker]({ commit }, workerData = null) {
        commit('SET_SELECTED_WORKER', workerData);
    },
    // 워커 필터 변경
    [actionType.setWorkerFilter]({ commit }, filterList = [
        mapControlAttendCode.ALL.code,
    ]) {
        commit('SET_WORKER_FILTER', filterList);
    },
    /**
     * 워커 추가
     * @param workerData 풀필먼트 워커 데이터
     */
    [actionType.addWorker]({ commit, dispatch }, workerData) {
        dispatch('updateStatusWorkerCount', {
            worker: workerData,
            isPlusFilterGroupCount: true,
            isDeletePrevFilterGroupCount: false,
        });
        commit('ADD_WORKER', workerData);
    },
    /**
     * 퇴근
     */
    [actionType.onOffWorker]({ commit }, payload) {
        commit('ON_OFF_WORKER', payload);
    },
    /**
     * 워커 데이터 업데이트
     * @param {*} param0
     * @param {*} workerData
     */
    [actionType.updateWorker]({ commit, state, dispatch }, workerData) {
        const { user: { code, }, } = workerData;
        const prevWorkerData = state.workerList[code];
        const workerStatus = parseWorkerAttendCode(workerData).toLowerCase();
        const prevWorkerStatus = parseWorkerAttendCode(prevWorkerData).toLowerCase();
        const newWorker = Object.assign(prevWorkerData, workerData);
        newWorker.updateOrderCount();
        if (newWorker.isTemporallyOff) {
            dispatch('onOffWorker', {
                code,
                flag: true,
            });
        }
        commit('UPDATE_WORKER', newWorker);
        if (workerStatus !== prevWorkerStatus) {
            dispatch('updateStatusWorkerCount', {
                worker: workerData,
                isPlusFilterGroupCount: true,
                isDeletePrevFilterGroupCount: true,
                // 푸시이벤트의 경우 updateWorker의 prevWorkerStatus가 waiting이더라도
                // updateStatusWorkerCount에서는 driviing으로 바뀔 수 있으므로 상태가 이전과
                // 다르면 prevWorkerStatus를 함께 보내준다
                prevWorkerStatus,
            });
        }
    },
    /**
     * 연관 라이더 추가
     * @param param0
     * @param workerCode
     */
    [actionType.addRelatedWorker]({ state, commit }, workerCode) {
        const relatedWorker = state.workerList[workerCode];
        if (!relatedWorker) {
            console.log(`[addRelatedWorker] Not exist worker. worker Id: ${workerCode}`);
            return;
        }
        relatedWorker.relatedWeight += 1;
        // 없을 때만 추가
        if (!state.relatedWorkerList[workerCode]) {
            commit('ADD_RELATED_WORKER_LIST', relatedWorker);
        }
    },
    /**
     * 연관 라이더 초기화 === 선택한 주문을 배차한 라이더
     * workerCode 없을시 모든 연관 라이더 제거
     * @param {*} param0
     * @param {string} workerCode
     */
    [actionType.clearRelatedWorker]({ state, commit }, workerCode) {
        const { relatedWorkerList, workerList, } = state;
        if (!workerCode) {
            Object.keys(relatedWorkerList).forEach((key) => {
                const worker = workerList[key];
                if (!worker) {
                    return;
                }
                worker.relatedWeight = 0;
            });
            commit('CLEAR_RELATED_WORKER_LIST');
            return;
        }
        const relatedWorker = workerList[workerCode];
        if (!relatedWorker) {
            return;
        }
        const { relatedWeight, } = relatedWorker;
        relatedWorker.relatedWeight = (relatedWeight - 1 <= 0)
            ? 0
            : relatedWorker.relatedWeight - 1;
        commit('CLEAR_RELATED_WORKER_LIST', workerCode);
    },
    /**
     * 워커 카운트 셋팅
     */
    [actionType.setWorkerTotalCount]({ state, commit, }) {
        const { workerList, mapVisibilitySetting: { isHideShareWorker, }, } = state;
        const workerTotal = {
            waiting: 0,
            driving: 0,
            rest: 0,
        };
        Object.values(workerList).forEach(({ user, isShareWorker }) => {
            // 공유워커는 공유워커숨김채크
            if (isShareWorker && isHideShareWorker) {
                return;
            }
            workerTotal[user.attendCode.toLowerCase()] += 1;
        });
        commit('SET_WORKER_TOTAL_COUNT', workerTotal);
    },
    [actionType.updateStatusWorkerCount]({ commit, state }, { worker, isPlusFilterGroupCount, isDeletePrevFilterGroupCount, prevWorkerStatus, }) {
        const { user: { code } } = worker;
        const prevWorkerData = state.workerList[code];
        const prevFilterGroupCount = isDeletePrevFilterGroupCount ? -1 : 0;
        const filterGroup = parseWorkerAttendCode(worker).toLowerCase();
        const filterGroupCount = isPlusFilterGroupCount ? +1 : -1;
        // updateWorker에서 prevWorkerStatus가 오면 그 값을 사용하고 그밖의 action에서 호출해 prevWorkerStatus가 없다면 prevWorkerData가 있는지 확인 후 해당 라이더의 현재 상태값을 넣어준다
        let prevFilterGroup = prevWorkerStatus;
        if (!prevFilterGroup) {
            prevFilterGroup = prevWorkerData ? parseWorkerAttendCode(prevWorkerData).toLowerCase() : null;
        }
        commit('UPDATE_STATUS_WORKER', {
            [prevFilterGroup]: prevFilterGroupCount,
            [filterGroup]: filterGroupCount,
        });
    },
    [actionType.deleteWorker]({ state, commit, dispatch }, workerCode) {
        try {
            const worker = state.workerList[workerCode];
            dispatch('updateStatusWorkerCount', {
                worker,
                isPlusFilterGroupCount: false,
                isDeletePrevFilterGroupCount: false,
            });
            commit('DELETE_WORKER', workerCode);
        }
        catch (error) {
            console.dir(error);
        }
    },
    [actionType.deleteAllWorker]({ commit }) {
        commit('DELETE_ALL_WORKER');
    },
    [actionType.inputSearchWorkerQuery]({ commit }, query) {
        commit('INPUT_SEARCH_WORKER_QUERY', query);
    },
    [actionType.setIsHideShareWorker]({ commit }, isHide) {
        commit('SET_IS_HIDE_SHARE_WORKER', isHide);
    },
    [actionType.setIsHideWorkerMarker]({ commit }, isHide) {
        commit('SET_IS_HIDE_WORKER_MARKER', isHide);
    },
};
export default action;
